// extracted by mini-css-extract-plugin
export default {"Products":"Products_Products__BXG0M"};